import { SxProps } from '@mui/material';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { hotjarEvent } from '../../util/hotjar';
import { useBoolFlag } from '../flags';
import { Icon } from '../icons';
import { MenuItem } from './menu-item';

interface Props {
  open?: boolean;
  showHelp?: boolean;
}

export const MenuFooter: FC<Props> = ({ open, showHelp }) => {
  const { t } = useTranslation(['common']);
  const displayPortalVersion = useBoolFlag('portals-display-portal-version-in-sidebar');
  const intercomGuideFlag = useBoolFlag('portals-intercom-guide-feature');
  const feedbackSidebarFlag = useBoolFlag('portals-feedback-sidebar-button-feature');

  const iconStyle: SxProps = {
    '& .icon': { minWidth: 72, width: 72 },
  };

  const build = import.meta.env.VITE_BUILD || import.meta.env.REACT_APP_BUILD; // TODO: DEV-371

  const getSubText = (): string => {
    const buildTimestamp = import.meta.env.VITE_BUILD_DATE || import.meta.env.REACT_APP_BUILD_DATE; // TODO: DEV-371
    if (!buildTimestamp) return t('common:component.navigation.update.labels.up-to-date');

    const buildDate = DateTime.fromISO(buildTimestamp);
    if (!buildDate.isValid) return t('common:component.navigation.update.labels.up-to-date');
    return buildDate.toLocal().toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
  };

  const handleSupportClick = (): void => {
    window.Intercom('show');
  };

  const handleFeedbackSidebarClick = (): void => {
    hotjarEvent('show_feedback_form');
  };

  return <>
    {(intercomGuideFlag && showHelp) ? <MenuItem icon={<Icon icon="Help" />} handleClick={handleSupportClick} open={open} sx={iconStyle} text={t('common:component.navigation.footer.labels.support')} /> : <></>}
    {(feedbackSidebarFlag) ? <MenuItem icon={<Icon icon="MessageSquare" />} handleClick={handleFeedbackSidebarClick} open={open} sx={iconStyle} text={t('common:common.labels.feedback')} /> : <></>}
    {displayPortalVersion ? <MenuItem icon={<Icon icon="Info" />} open={open} sx={{ ...iconStyle, cursor: 'default' }} subText={getSubText()} text={t('common:common.labels.version', { build: build ?? t('common:component.navigation.update.labels.manualBuild') })} /> : <></>}
  </>;
};
